/* ============================================================
   ai-section-motion.js  —  baseline 入场 reveal 引擎（系统资产 · Tier 0）
   ------------------------------------------------------------
   只管入场 reveal：IntersectionObserver 把 [data-reveal] 从 --ai-reveal:0 翻到 1（CSS transition 平滑 + stagger）。
   只 setProperty 冻结契约变量，不碰视觉（视觉全在 ai-section-motion.css，引擎可换 / recipe 不动）。
   reduced-motion：不驱动，CSS 兜底为静止 + 完全可见。
   注：滚动进度 --ai-motion-progress 已收敛进通用引擎 ai-cinematic-motion.js（同一公式，唯一 rAF，§16.7），
       本引擎只剩 IO reveal，不再起 rAF / scroll 循环。
   ============================================================ */
(function () {
  if (window.__aiSectionMotion) return;            // 防重复初始化（多 section 共用一份）
  window.__aiSectionMotion = true;

  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  var io = reduce ? null : new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.style.setProperty('--ai-reveal', '1');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });

  /* arm：把 reveal 单元先压到 0 再观察；可被动态插入的 section 复用（编辑器场景） */
  function arm(root) {
    if (reduce) return;                            // 减动：CSS 兜底，无需引擎介入
    (root || document).querySelectorAll('[data-reveal]').forEach(function (el) {
      if (el.__aiArmed) return;
      el.__aiArmed = true;
      el.style.setProperty('--ai-reveal', '0');
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { arm(document); });
  else arm(document);

  /* 暴露 re-arm，供 Shopify 编辑器动态插入 section 后重新挂载 */
  window.aiSectionMotion = { arm: arm };
  document.addEventListener('shopify:section:load', function (e) { arm(e.target); });
})();
